import React, { useEffect, useContext } from 'react';
import * as R from 'ramda';
import { store } from './store';
import { postJSONPS } from '@cd/utils';
import { either } from '@cd/utils';

export const SecureApp = R.curry((Cmp, props) => {
	const {
		dispatch,
		state: { auth }
	} = useContext(store);

	useEffect(() => {
		postJSONPS('POST', '/auth/session', {}).then(
			either(
				() => {
					dispatch({ type: 'set session', session: null });
					window.location.href = 'https://www.cyberdev.us';
				},
				({ session, url }) => {
					if (session) {
						dispatch({ type: 'set session', session });
					} else {
						window.location.href = url;
					}
				}
			)
		);
	}, []);

	return auth.session && <Cmp {...props} />;
});
